import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_1";
import BlockPrincipal from "../components/block/Block_2";
import BlockSecondary from "../components/block/Block_8";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[5]}`}
        />
        <BlockPrincipal
            title={'about us'}
            text={rpdata?.dbAbout?.[0]?.text}
            image={rpdata?.stock?.[0]}
            listsAbout
          />
        <ValuesOne image={rpdata?.stock?.[1]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image1={rpdata?.gallery?.[7]}
          image2={rpdata?.gallery?.[0]}
          image3={rpdata?.gallery?.[1]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
